
import { defineComponent } from "vue";
import { previewGhlSitePageUrl } from "@/api/ghlSites.api.js";

export default defineComponent({
  name: "SitePreview",
  data() {
    return {
      loading: true,
      error: "",
      previewHtml: "",
      previewKey: ""
    };
  },
  computed: {
    siteId(): string {
      return String(this.$route.params.id || "");
    },
    pageId(): string {
      return String(this.$route.query.pageId || "");
    },
    previewUrl(): string {
      if (!this.siteId || !this.pageId) {
        return "";
      }
      const cacheBuster = this.$route.query.t || Date.now();
      return `${previewGhlSitePageUrl(this.siteId, this.pageId)}?t=${cacheBuster}`;
    }
  },
  watch: {
    previewUrl: {
      immediate: true,
      handler() {
        this.loadPreview();
      }
    }
  },
  methods: {
    async loadPreview() {
      if (!this.previewUrl) {
        this.loading = false;
        this.error = "Missing preview parameters.";
        return;
      }

      this.loading = true;
      this.error = "";
      this.previewHtml = "";

      try {
        const response = await fetch(this.previewUrl, { credentials: "omit" });
        const html = await response.text();
        if (!response.ok) {
          this.error = response.status === 404 ? "Preview not found." : "Preview unavailable.";
          return;
        }
        this.previewHtml = html;
        this.previewKey = this.previewUrl;
      } catch (err) {
        this.error = "Failed to load preview.";
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  }
});
